const LOGIN_SET_LOGOUT = 'LOGIN_SET_LOGOUT'
const LOGIN_SET_IS_AUTHORIZED = 'LOGIN_SET_IS_AUTHORIZED'
const LOGIN_SET_IS_INPUT_CLICK = 'LOGIN_SET_IS_INPUT_CLICK'
const LOGIN_SET_MY_PROFILE = 'LOGIN_SET_MY_PROFILE'

const loginTypes = {
    LOGIN_SET_LOGOUT,
    LOGIN_SET_IS_AUTHORIZED,
    LOGIN_SET_IS_INPUT_CLICK,
    LOGIN_SET_MY_PROFILE
}

export default loginTypes